import { BaseEntityLineChart } from '../../../components/Charts';
import { useTHPTChart } from '../hooks/useTHPTChart';
import { useAppSelector } from '../../../store/hooks';

interface THPTChartProps {
	height?: number;
}

export function THPTChart({ height = 400 }: THPTChartProps) {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const { nivoData, isLoading, error } = useTHPTChart({
		filters: {
			maKhoa: selectedFaculty ? [selectedFaculty] : undefined
		}
	});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Trường THPT"
			downloadFilename="bieu-do-truong-thpt"
			entityLabel="Chọn trường"
			entityPlaceholder="Tất cả trường"
			groupByEntity
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
